import { render, staticRenderFns } from "./VerificationCode.vue?vue&type=template&id=11ed3c72&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"
import style0 from "./VerificationCode.vue?vue&type=style&index=0&id=11ed3c72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed3c72",
  null
  
)

export default component.exports